import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { CoinInfo } from '../pages/core/utils/cryptoCoinInfo';

@Injectable({
  providedIn: 'root',
})
export class IsVisibleCardGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (CoinInfo[route.params.ticker]?.visible) {
      return true;
    }

    return this.router.navigateByUrl('/crypto-exchange');
  }
}
